import { useEffect } from 'react';

// Detector global de navegación por teclado. Marca `keyboard-nav` en el body
// mientras el usuario usa el teclado y lo retira al usar el puntero, para que
// los estilos de focus visible se muestren solo al tabular y no al hacer click.
let installed = false;

function handleKeydown(event) {
  if (event.key === 'Tab') {
    document.body.classList.add('keyboard-nav');
  }
}

function handlePointer() {
  document.body.classList.remove('keyboard-nav');
}

function installKeyboardNav() {
  if (installed) return;
  installed = true;
  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('mousedown', handlePointer);
  document.addEventListener('pointerdown', handlePointer);
}

export default function useKeyboardNav() {
  useEffect(() => {
    installKeyboardNav();
  }, []);
}
